/**
 * @file 路由渲染
 * @author liwei.zhu
 */
import React, { Component, Fragment, Suspense } from 'react';
import { observable, action } from 'mobx';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { Route, Switch, Redirect } from 'react-router-dom';
import Exception from 'pages/common/exception';
import can from 'pages/common/decorators/can';
import routerList from 'routers';

@can()
@observer
export default class Router extends Component {
    @observable exportDefaultPath = '/'; // 进入首页后打开的第一个有权限页面

    static propTypes = {
        can: PropTypes.func.isRequired,
    };

    @action
    renderRouter(list, parentPath = '') {
        const { can } = this.props;
        if (list.length === 0) {
            return <Route key="/no-permission" path="/no-permission" render={() => <Exception pageType="403" />} />;
        }
        return list.map(val => {
            if (val.children && val.children.length > 0) {
                // 判断是否是父层
                return this.renderRouter(val.children, val.path);
            } else {
                let path;
                if (parentPath && parentPath != '/') {
                    path = parentPath + '/' + val.path;
                } else if (parentPath == '/') {
                    path = parentPath + val.path;
                }

                if (val.permission && !can(val.permission)) {
                    // 判断是否有权限
                    return <Route key={path} path={path} render={() => <Exception pageType="403" />} />;
                }

                if (this.exportDefaultPath == '/' && !val.hideInMenu) {
                    this.exportDefaultPath = path;
                }
                return <Route key={path} path={path} component={val.component} />;
            }
        });
    }
    render() {
        return (
            <Fragment>
                <Suspense fallback={null}>
                    <Switch>
                        {this.renderRouter(routerList)}
                        <Redirect exact from="/" to={this.exportDefaultPath} />
                        <Route component={Exception} />
                    </Switch>
                </Suspense>
            </Fragment>
        );
    }
}
